/**
 * Afghan afghani.
 */
export var AFN = {
  code: 'AFN',
  base: 10,
  exponent: 2
};